import { render, staticRenderFns } from "./Tertunda.vue?vue&type=template&id=1c35bfe7&"
import script from "./Tertunda.vue?vue&type=script&lang=js&"
export * from "./Tertunda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports